import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { FieldInterventionEntitiesService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class FieldInterventionEntitiesListBloc extends Bloc<
    FieldInterventionEntitiesService['fieldInterventionEntityControllerGet']
> {
    public constructor(service: FieldInterventionEntitiesService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.fieldInterventionEntityControllerGet.bind(service), {
            debug: debug ?? false,
        });
    }
}
